import firebase from "firebase/app";
import 'firebase/firestore'

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAtVyRrj1AnK9EW-e6Er1cF_W2qrzBZ-2Y",
  authDomain: "vue-keeper-typescript.firebaseapp.com",
  databaseURL: "https://vue-keeper-typescript-default-rtdb.firebaseio.com",
  projectId: "vue-keeper-typescript",
  storageBucket: "vue-keeper-typescript.appspot.com",
  messagingSenderId: "1002388201215",
  appId: "1:1002388201215:web:b7f970061fc3b95bccf6ca",
  measurementId: "G-N2QG1BBQGR"
});

const db = firebaseApp.firestore();

export { db };